import React from 'react';
import { BRAND_LIBRARY_DARK_TEXT_COLOR } from 'common/constants/brandLibrary';

import Headline from './UpcomingSessionsHeadline.styles';

const UpcomingSessionsHeadline = (props) => <Headline {...props} />;

UpcomingSessionsHeadline.splash = {
    ...Headline.splash,
    defaultProps: {
        ...Headline.splash.defaultProps,
        styles: {
            ...Headline.splash.defaultProps.styles,
            fontColor: BRAND_LIBRARY_DARK_TEXT_COLOR,
        },
        meta: {
            ...Headline.splash.defaultProps.meta,
            content: 'Upcoming Sessions',
        },
    },
};

export default UpcomingSessionsHeadline;
